import * as Sentry from '@sentry/vue';

import type { AnalyticsEvent, AnalyticsParams } from '../events';
import { TrackingDestination } from './TrackingDestination';

/** Tracking for Sentry. Adds breadcrumbs to the events made by the user. */
export class SentryDestination extends TrackingDestination {
  protected isEnabled(): boolean {
    return Sentry.isInitialized();
  }

  protected send(event: AnalyticsEvent, payload: AnalyticsParams): void {
    Sentry.addBreadcrumb({
      category: 'analytics',
      message: event,
      data: payload,
      level: 'info',
    });
  }
}
